// extracted by mini-css-extract-plugin
export default {"tooltipWrapper":"SSNInput_tooltipWrapper__Sbx-c"};